import React, { useEffect, useState } from "react";
import { toast } from "../components/ui/sonner";
import { useApp } from "../context/AppContext";
import { Loader2, CheckCircle2, Clock3, MapPin } from "lucide-react";

/* 铃铛内联「值班确认」：hrms_duty / hrms_duty_nudge 提醒直接点「确认」 */
export const DutyInline = ({ reminder, compact = false, onChanged }) => {
  const { api, lang } = useApp();
  const zh = lang === "zh";
  const did = reminder.dutyId;
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [gone, setGone] = useState(false);
  useEffect(() => { if (did) api.get(`/hrms/schedule/duties/${did}`).then((r) => setD(r.data)).catch(() => setGone(true)); }, [api, did]);
  if (!did || gone) return null;
  if (!d) return <p className="text-[10px] text-slate-400"><Loader2 className="h-3 w-3 animate-spin inline" /></p>;
  const confirm = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try { await api.post(`/hrms/schedule/duties/${did}/confirm`); setD({ ...d, status: "confirmed" }); toast.success(zh ? "已确认值班安排" : "Duty confirmed"); onChanged?.(); }
    catch (err) { toast.error(err?.response?.data?.detail || (zh ? "确认失败" : "Failed")); } finally { setBusy(false); }
  };
  return (
    <div className={`flex items-center gap-2 ${compact ? "text-[10px]" : "text-[11px]"}`} data-testid={`duty-inline-${reminder.id}`} data-status={d.status}>
      <span className="text-slate-500 inline-flex items-center gap-1 min-w-0 truncate">
        {d.location && <><MapPin className="h-3 w-3 shrink-0" />{d.location}</>}
      </span>
      {d.cancelledAt ? (
        <span className="text-slate-400" data-testid={`duty-inline-status-${reminder.id}`}>{zh ? "已取消" : "Cancelled"}</span>
      ) : d.status === "confirmed" ? (
        <span className="inline-flex items-center gap-1 text-emerald-600 font-semibold" data-testid={`duty-inline-status-${reminder.id}`}><CheckCircle2 className="h-3 w-3" />{zh ? "已确认" : "Confirmed"}</span>
      ) : d.isMine ? (
        <button type="button" data-testid={`duty-inline-confirm-${reminder.id}`} disabled={busy} onClick={confirm}
          className="ml-auto inline-flex items-center gap-1 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-2.5 py-1 disabled:opacity-50">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <CheckCircle2 className="h-3 w-3" />}{zh ? "确认值班" : "Confirm"}
        </button>
      ) : (
        <span className="inline-flex items-center gap-1 text-amber-600" data-testid={`duty-inline-status-${reminder.id}`}><Clock3 className="h-3 w-3" />{zh ? "待确认" : "Pending"}</span>
      )}
    </div>
  );
};
